import {useMemo} from "react";
import {Users} from "lucide-react";
import {getTeamGroup} from "./teamFilters";
import {useTeamMembers} from "./useTeamMembers";

/** Page header title for /team: icon tile, "Team", and member / available counts. */
const TeamHeaderTitle = () => {
    const {members, hasStatuses, isLoading} = useTeamMembers();

    const availableCount = useMemo(
        () => members.filter(member => getTeamGroup(member) === 'AVAILABLE').length,
        [members],
    );

    return (
        <div className="flex h-[56px] items-center gap-3">
            <span className="flex size-9 shrink-0 items-center justify-center rounded-control bg-ink-secondary text-white">
                <Users size={20} aria-hidden="true" className="!p-0 !text-current"/>
            </span>
            <h1 className="m-0 text-[24px] font-medium leading-tight text-ink">Team</h1>
            {!isLoading && hasStatuses && (
                <span data-testid="team-header-counts" className="text-footnote text-ink-muted">
                    {members.length} {members.length === 1 ? 'member' : 'members'} · {availableCount} available
                </span>
            )}
        </div>
    );
};

export default TeamHeaderTitle;
